import axios from 'axios';
import i18n from 'i18next';
import queryString from 'query-string';
import cookies from 'js-cookie';
import intervalPlural from 'i18next-intervalplural-postprocessor';
const HTTPApi = require('i18next-http-backend');

require.context('../resources/translations/', true, /\.(\w){2}-(\w){2}\.yml$/);

const getReferralLocale = () => {
  const search = queryString.parse(window.location.search);
  if (search.setLocale) {
    cookies.set('locale', search.setLocale);
    if (search.setLocale === 'zh-cn') {
      cookies.set('i18next', 'cn');
    } else if (search.setLocale === 'en-us') {
      cookies.set('i18next', 'en');
    }

    return search.setLocale;
  }

  return false;
};

const locale = getReferralLocale() || cookies.get('locale') || 'en-us';

const config = {
  debug: false,
  fallbackLng: 'en-us',
  lowerCaseLng: true,
  load: 'currentOnly',
  keySeparator: '=>',
  ns: ['landlord', 'cms'],
  defaultNS: 'landlord',
  lng: locale,
  interpolation: {
    escapeValue: false,
    prefix: '%',
    suffix: '%',
  },
  react: {
    wait: true,
  },
  backend: {
    loadPath:
      process.env.PUBLIC_URL +
      `/%ns%.%lng%${process.env.PUBLISH_TIME ? '.' + process.env.PUBLISH_TIME + '.json' : '.json'}`,
    ajax: (url, options, callback) => {
      axios
        .get(url, {
          headers: {
            'Cache-Control': 'no-cache',
          },
        })
        .then(response => {
          callback(JSON.stringify(response.data), response);
        })
        .catch(e => {
          callback(null, {
            status: 404,
          });
          throw e;
        });
    },
  },
};

i18n.use(intervalPlural).use(HTTPApi).init(config);

export default i18n;
